import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  connect() {
    console.log("✅ Sortable Nouveautés connecté!", this.itemTargets.length, "parfums")
    this.isDragging = false
    this.setupDragAndDrop()
  }

  setupDragAndDrop() {
    this.itemTargets.forEach((item, index) => {
      // S'assurer que l'élément est draggable
      item.setAttribute('draggable', 'true')
      item.dataset.originalPosition = index
      
      // Event: Début du drag
      item.addEventListener('dragstart', (e) => {
        this.isDragging = true
        e.dataTransfer.effectAllowed = 'move'
        e.dataTransfer.setData('text/plain', item.dataset.parfumId)
        item.classList.add('dragging')
        item.style.opacity = '0.4'
        console.log("🎯 Début du drag:", item.dataset.parfumId)
      })
      
      // Event: Fin du drag
      item.addEventListener('dragend', (e) => {
        item.classList.remove('dragging')
        item.style.opacity = '1'
        
        if (this.isDragging) {
          console.log("📍 Fin du drag, sauvegarde...")
          this.isDragging = false
          
          // Attendre un peu que le DOM se stabilise
          setTimeout(() => {
            this.saveNewOrder()
          }, 100)
        }
      })
      
      // Event: Survol pendant le drag
      item.addEventListener('dragover', (e) => {
        e.preventDefault()
        e.dataTransfer.dropEffect = 'move'
        
        const draggingItem = this.element.querySelector('.dragging')
        
        if (draggingItem && draggingItem !== item) {
          const rect = item.getBoundingClientRect()
          const midpoint = rect.top + rect.height / 2
          
          if (e.clientY < midpoint) {
            // Insérer avant
            item.parentNode.insertBefore(draggingItem, item)
          } else {
            // Insérer après
            item.parentNode.insertBefore(draggingItem, item.nextSibling)
          }
        }
      })

      // Event: Enter
      item.addEventListener('dragenter', (e) => {
        e.preventDefault()
      })

      // Event: Drop
      item.addEventListener('drop', (e) => {
        e.preventDefault()
      })
    })
  }

  async saveNewOrder() {
    console.log("💾 Début de la sauvegarde...")
    
    // Récupérer tous les items dans leur ordre actuel
    const items = Array.from(this.itemTargets)
    
    // Créer le mapping position -> parfum_id
    const updates = items.map((item, newIndex) => {
      const parfumId = item.dataset.parfumId
      console.log(`  Position ${newIndex}: Parfum #${parfumId}`)
      return {
        id: parseInt(parfumId),
        position: newIndex
      }
    })

    console.log("📦 Ordre complet à sauvegarder:", updates)

    try {
      // Sauvegarder chaque position
      let successCount = 0
      
      for (const update of updates) {
        const success = await this.updatePosition(update.id, update.position)
        if (success) {
          successCount++
        }
      }
      
      console.log(`✅ ${successCount}/${updates.length} positions sauvegardées`)
      this.showNotification(`✅ Ordre mis à jour (${successCount} parfums)`, 'success')
      
    } catch (error) {
      console.error('❌ Erreur complète:', error)
      this.showNotification('❌ Erreur: ' + error.message, 'danger')
      
      // Recharger après 2 secondes en cas d'erreur
      setTimeout(() => location.reload(), 2000)
    }
  }

  async updatePosition(parfumId, newPosition) {
    // URL CORRECTE avec l'ID du parfum
    const url = `/admin_panel/parfums/${parfumId}/update_position`
    
    console.log(`  🔄 PATCH ${url} (position: ${newPosition})`)
    
    try {
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': this.getCsrfToken()
        },
        body: JSON.stringify({ position: newPosition })
      })
      
      console.log(`  📡 Response status: ${response.status}`)
      
      if (!response.ok) {
        const text = await response.text()
        console.error(`  ❌ Erreur serveur:`, text)
        throw new Error(`HTTP ${response.status}: ${text.substring(0, 100)}`)
      }
      
      const data = await response.json()
      console.log(`  ✅ Succès:`, data)
      
      return data.success
      
    } catch (error) {
      console.error(`  ❌ Erreur fetch pour parfum ${parfumId}:`, error)
      throw error
    }
  }

  getCsrfToken() {
    const token = document.querySelector('[name="csrf-token"]')
    if (!token) {
      console.warn('⚠️ CSRF token non trouvé!')
      return ''
    }
    return token.content
  }

  showNotification(message, type) {
    // Supprimer l'ancienne notification
    const old = document.querySelector('.sortable-notification')
    if (old) old.remove()

    // Créer la notification
    const notif = document.createElement('div')
    notif.className = `alert alert-${type} position-fixed sortable-notification shadow-lg`
    notif.style.cssText = `
      top: 80px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9999;
      min-width: 300px;
      text-align: center;
      animation: slideDown 0.3s ease;
    `
    notif.textContent = message
    
    document.body.appendChild(notif)
    
    setTimeout(() => {
      notif.style.animation = 'slideUp 0.3s ease'
      setTimeout(() => notif.remove(), 300)
    }, 3000)
  }
}

// Styles CSS
if (!document.querySelector('#sortable-styles')) {
  const style = document.createElement('style')
  style.id = 'sortable-styles'
  style.textContent = `
    @keyframes slideDown {
      from {
        opacity: 0;
        transform: translateX(-50%) translateY(-20px);
      }
      to {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
      }
    }
    
    @keyframes slideUp {
      from {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
      }
      to {
        opacity: 0;
        transform: translateX(-50%) translateY(-20px);
      }
    }
    
    .dragging {
      opacity: 0.4 !important;
      cursor: grabbing !important;
      border: 2px dashed #6c757d !important;
      background-color: #f8f9fa !important;
    }
    
    [draggable="true"] {
      cursor: grab !important;
      transition: all 0.2s ease;
    }
    
    [draggable="true"]:hover {
      background-color: #f8f9fa !important;
    }
    
    .cursor-move {
      cursor: grab !important;
      user-select: none;
    }
    
    .cursor-move:active {
      cursor: grabbing !important;
    }
    
    .list-group-item {
      transition: background-color 0.2s ease;
    }
  `
  document.head.appendChild(style)
}